module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "weui-search-bar",
    attrs: {
      "id": "searchBar"
    }
  }, [_c('form', {
    staticClass: "weui-search-bar__form"
  }, [_c('div', {
    staticClass: "weui-search-bar__box"
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "weui-search-bar__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.content)
    },
    on: {
      "click": _vm.focusing,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }, _vm.onInput],
      "change": _vm.onInput,
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "weui-icon-clear",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.clear
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.focus),
      expression: "!focus"
    }],
    staticClass: "weui-search-bar__label",
    on: {
      "click": _vm.focusing
    }
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('span', [_vm._v("搜索")])])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.focus),
      expression: "focus"
    }],
    staticClass: "weui-search-bar__cancel-btn",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.focus),
      expression: "focus"
    }],
    staticClass: "weui-cells searchbar-result"
  }, [_vm._l((_vm.resultList), function(result) {
    return [_c('div', {
      staticClass: "weui-cell weui-cell_access",
      on: {
        "click": function($event) {
          _vm.selectIt(result)
        }
      }
    }, [_c('div', {
      staticClass: "weui-cell__bd weui-cell_primary"
    }, [_c('p', [_vm._v(_vm._s(result))])])])]
  })], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-0600e694!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/search_bar/search-bar.vue
// module id = 217
// module chunks = 0